// REDUX
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
// REDUCERS
import rootReducer from './reducers/Reducer';

// Create the Redux  store
export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
